<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter2">
<h1 class="left"><a href="#/004toc#january2">January 2</a></h1>
<p class="noindent">Finding the time to pursue your dreams can be difficult, especially when a restless spirit continually tries to take possession of you. Just keep your eyes on the prize and a bottle of holy water in your pocket—everything else will take care of itself.</p>
<p class="indent"><em>Dark days:</em> Monday, Friday</p>
<div class="image" id="image4">
<p class="center"><img alt="image 4" src="images/StarRule.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007chapter2.vue?41597d7a